export const incNumber = (num) => {
    return {
        type: 'INCREMENT',
        payload: num
    }
}

export const decNumber = () => {
    return {
        type: 'DECREMENT'
    }
};

export const saveInputParam = (values) => {
    return {
        type: 'SAVEINPUTPARAMS',
        payload: values
    }
};

export const saveSelectedPlant = (values) => {
    return {
        type: 'SAVESELECTEDPLANT',
        payload: values
    }
};

export const saveSelectedMachineType = (values) => {
    return {
        type: 'SAVESELECTEDMACHINETYPE',
        payload: values
    }
};

export const saveSelectedLine = (values) => {
    return {
        type: 'SAVESELECTEDLINE',
        payload: values
    }
};

export const saveSelectedMachine = (values) => {
    return {
        type: 'SAVESELECTEDMACHINE',
        payload: values
    }
};

export const saveSelectedShift = (values) => {
    return {
        type: 'SAVESELECTEDSHIFT',
        payload: values
    }
};

export const saveSelectedShiftDate = (values) => {
    return {
        type: 'SAVESELECTEDSHIFTDATE',
        payload: values
    }
};

export const saveTimings = (values) => {
    return {
        type: values.type,
        payload: values.payload
    }
};